import React from 'react';
import styled from 'styled-components';

import { ReactComponent as ZoomIcon } from '@/assets/icons/zoom-icon.svg';
import { ReactComponent as ZoomMinusIcon } from '@/assets/icons/zoom-minus.svg';
import { ReactComponent as ZoomPlusIcon } from '@/assets/icons/zoom-plus.svg';

import { ZoomLevel } from '../../hooks/useZoomLevel';

interface GanttZoomControlsProps {
  canZoomIn: boolean;
  canZoomOut: boolean;
  currentZoom: ZoomLevel;
  onZoomIn: () => void;
  onZoomOut: () => void;
}

const GanttZoomControls: React.FC<GanttZoomControlsProps> = ({
  currentZoom,
  onZoomIn,
  onZoomOut,
  canZoomIn,
  canZoomOut,
}) => {
  return (
    <ZoomContainer>
      <ZoomButton onClick={onZoomOut} disabled={!canZoomOut} title="Zoom Out">
        <ZoomMinusIcon />
      </ZoomButton>

      <ZoomIndicator title={currentZoom.label}>
        <ZoomIcon />
        {currentZoom.label && <ZoomLevelText>{currentZoom.label}</ZoomLevelText>}
      </ZoomIndicator>

      <ZoomButton onClick={onZoomIn} disabled={!canZoomIn} title="Zoom In">
        <ZoomPlusIcon />
      </ZoomButton>
    </ZoomContainer>
  );
};

const ZoomContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px;
  background-color: ${({ theme }) => theme.palette.brand.white};
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.palette.brand.backgroundMain};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  height: 35px;
`;

const ZoomButton = styled.button<{ disabled: boolean }>`
  background: none;
  border: none;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  svg {
    width: 16px;
    height: 16px;
  }
`;

const ZoomIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-left: 1px solid #dfdfdf;
  border-right: 1px solid #dfdfdf;

  svg {
    width: 25px;
    height: 25px;
  }
`;

const ZoomLevelText = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
  white-space: nowrap;
`;

export { GanttZoomControls };
